module.exports = __webpack_public_path__ + "static/media/tableDisponibilidad.f4a7118a.png";